import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./hooks/GlobalProvider.js";
import DomainRenew from "./components/Tools/DomainRenew.js";
import UnderConstruction from "./components/UnderConstruction.js";
function DomainRenewWrapper() {
  const location = useLocation();

  // Hide on /login and /auth/*
  if (location.pathname === "/login" || location.pathname.startsWith("/auth")) {
    return null;
  }

  return <DomainRenew />;
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <AuthProvider>
        <HelmetProvider>
          {/* Conditional DomainRenew */}
          <DomainRenewWrapper />

          {/* Main App */}
          <App />
        </HelmetProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
